"use client";

import { FC } from "react";
import { Download } from "react-bootstrap-icons";

import ActionButton from "@/components/action-button/ActionButton";

const DownloadButton: FC = () => {
  const handleClick = async () => {
    const response = await fetch(`${process.env.SITE_URL}/api/file`);

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "rb-resume.pdf";
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <ActionButton handler={handleClick}>
      <Download /> Download Resume
    </ActionButton>
  );
};

export default DownloadButton;
